import { apiSlice } from "@/services/http";
import { Tags } from "@/enum/tags";
import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

export interface ManualRefresh {
  refresh: () => void;
  refreshedAt: Date | null;
}

export const useManualRefresh = (invalidates: readonly Tags[]): ManualRefresh => {
  const dispatch = useDispatch();
  const [refreshedAt, setRefreshedAt] = useState<Date | null>(null);

  const tagsKey: string = invalidates.join(",");

  const refresh = useCallback((): void => {
    dispatch(apiSlice.util.invalidateTags(tagsKey.split(",") as Tags[]));
    setRefreshedAt(new Date());
  }, [dispatch, tagsKey]);

  return { refresh, refreshedAt };
};
